import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Divider, TextField, FlatButton, RaisedButton, Card, CardText, Dialog, DatePicker,
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, SelectField, MenuItem,
  Checkbox, IconButton, CircularProgress,
} from "material-ui";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import Editar from "material-ui/svg-icons/image/edit";
import DateIcon from "material-ui/svg-icons/action/date-range";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import customDateTimeFormat from "../../../helpers/dateFormat";
import {
  OpenConfirmacionGuardadoEdicion, CloseConfirmacionGuardadoEdicion, GuardarValorArancelMod,
  GuardarValorPrestacionesMod, CambiarUnidadGrillaMod, LimpiarErroresGrillaMod, showErrorTipo, showErrorDesc, showErrorPres,
  CambiarUnidadReplicar, obtenerValorMaxPrestacion, DisplayEditErrorText, CambiarDescCaracteristica, openModalCaracteristicas, openModalNuevaPrestacion,
  OpenCargarBorrador, CambiarMontoArancelPrestacion, CambiarMontoArancelError, /*CambiarPrestacionesSeleccionadas,*/
  CambiarCheckRowsMod, CambiarCheckRowsModArancel, ShowDupsMsg, ValidarRelacionSecInstitucion, CambiarCaracteristica, CambiarTipoCaracteristica,
} from "./actions";
import {
  CloseEditarPrestacion, CargardetallePrestacion, cargarCaracteristicasMod, addCaracteristica, eliminarCaracteristica, CargardetalleNuevaPrestacion, cargarDetalleMod,
  CambiarPrestacionesSeleccionadas, eliminarPrestaciones, cargarDetallePaquete, CambiarCodPrestador, CambiarGlosaPrestador, CambiarCodIsapre, CambiarCodProfesional, CambiarTipoAtencion,
  CambiarItemImed, CambiarCantidadPres, CambiarCodIntervPres, CambiarGlosaIntervPres, CambiarGlosaPaquetePres, CambiarCodigoPaquetePres, CambiarMedicoUHoteleria, CambiarUnidad,
  CambiarRutBono, CambiarMonto, GuardardetallePrestacion, GuardardetalleNuevaPrestacion, openModalDetallePrestacion, CambiarVigenciaPrestacionEdicion, limpiarPaqueteEditar
} from "../GrillaBusquedaPQ/actions";
import { AddPrestacionSolicitud, CargarPrestacionSolicitud } from "../GrillaSolicitud/actions";
import { obtenerTiposAtencion } from "../FiltroBusquedaPQ/actions";

import { ObtenerTiposUnidad, ObtenerTipoProfesional } from "../../Global/actions";
import guid from "../../../helpers/guid";
import styles from "./../../styles/styles";
import valorUnidad from "../../../helpers/valorUnidad";


class EditarPaqueteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      infoAlert: false,
      infoAlert2: false,
      infoMensaje: "",
      infoMensaje2: "",
      infomensaje3: "",
      errorFecha: "",
      index: null,
      presSeleccionadas: [],
      disabledEditar: true,
      disabledEliminar: true,
      disabledCaracteristicas: false,
      esModificacion: false,
      esRepetida: false,
      esRepetidaEditar: false,
      errorPres: false,
      modalConfirmacion: false,
      modalFechainicio: false,
      fechaInicioMod: "",
    };
  }

  componentWillMount() {
    this.props.dispatch(ObtenerTiposUnidad());
    this.props.dispatch(ObtenerTipoProfesional());
    this.props.dispatch(obtenerValorMaxPrestacion());
  }

  ocultarModalBorrador = () => {
    this.props.dispatch(OpenCargarBorrador(false));
  }

  CloseEditarPrestacion = () => {
    this.props.dispatch(CloseEditarPrestacion());
  }

  OpenConfirmacionGuardadoEdicion = () => {
    this.props.dispatch(OpenConfirmacionGuardadoEdicion());
  };

  CloseConfirmacionGuardadoEdicion = () => {
    this.props.dispatch(CloseConfirmacionGuardadoEdicion());
  };

  CambiarVigenciaPrestacionEdicion = (event, date) => {
    this.props.dispatch(CambiarVigenciaPrestacionEdicion(date));
    this.setState({ esModificacion: true });
  }

  LimpiarVigenciaPrestacionEdicion = (date) => {
    this.props.dispatch(CambiarVigenciaPrestacionEdicion(date));
    this.ValidarLimpiarFecha();
  }

  ValidarLimpiarFecha = () => {
    let paqueteEditar = this.props.paqueteEditar;
    let paqueteEditarMod = this.props.paqueteEditarMod;
    let caractPaquete = this.props.caracteristicasPaquete;
    let caractPaqueteMod = this.props.caracteristicasPaqueteMod;
    let prestaciones = this.props.detallePaquete;
    let prestacionesMod = this.props.detallePaqueteMod;
    //console.log(paqueteEditarMod)
    var resultValidacionInfoPaquete = this.validadModificacionInformacion2(paqueteEditar, paqueteEditarMod);
    var resultValidacionCaractPaquete = this.validadModificacionCaracteristicas(caractPaquete, caractPaqueteMod);
    var resultValidacionPrestaciones = this.validadModificacionPrestaciones(prestaciones, prestacionesMod);

    //console.log(resultValidacionInfoPaquete)
    if (resultValidacionInfoPaquete === true) {
      this.setState({ esModificacion: false });
    } else if (resultValidacionCaractPaquete === false || resultValidacionPrestaciones === false || resultValidacionInfoPaquete === false) {
      this.setState({ esModificacion: true });
    }
  }

  CambiarVigenciaPaqueteEdicion = (event, date) => {
    this.setState({ fechaInicioMod: date, errorFecha: "" });
  }

  showInfoAlert = (mensaje, index) => {
    this.setState({ infoAlert: true, infoMensaje: mensaje, index: index });
  }

  showInfoAlert2 = (mensaje) => {
    this.setState({ infoAlert2: true, infoMensaje2: mensaje });
  }

  checkCaracteristicas = () => {
    const unique = [...new Set(this.props.caracteristicas.map(item => item.Tipo))];
    if (unique.length === this.props.caracteristicasPaqueteMod.length) {
      this.state.disabledCaracteristicas = true;
    }
  }

  CambiarCaracteristica = (event, index, value) => {
    let aux = 0;
    let tipo = value.substring(0, value.indexOf("-"));
    let desc = value.substring(value.indexOf("-") + 1, value.length);
    this.props.dispatch(CambiarCaracteristica(tipo, desc));

    for (let i = 0; i < this.props.caracteristicasPaquete.length; i++) {
      if (this.props.caracteristicasPaquete[i].Tipo == tipo && this.props.caracteristicasPaquete[i].Descripcion == desc) {
        this.setState({ esModificacion: false });
        aux = 1;
      }
    }
    if (aux == 0) {
      this.setState({ esModificacion: true });
    }
  }

  menuListTipoAtributo = (tipo) => {
    const menuListTipoAtributo = [];
    const result = this.props.caracteristicas.filter(tipos => tipos.Tipo === tipo);
    for (let i = 1; i <= result.length; i++) {
      menuListTipoAtributo.push(<MenuItem key={i} value={result[i - 1].Tipo + "-" + result[i - 1].Descripcion} primaryText={result[i - 1].Descripcion} style={styles.customWidthItem} />);
    }
    return menuListTipoAtributo;
  }

  CargarAtributosTipo = (event, index, value) => {
    this.props.dispatch(showErrorTipo(""));
    this.props.dispatch(CambiarTipoCaracteristica(value));
  }

  GuardarAtributos = (event, index, value) => {
    this.props.dispatch(showErrorDesc(""));
    this.props.dispatch(CambiarDescCaracteristica(value));
  }

  addCaracteristica = () => {
    this.props.dispatch(CambiarTipoCaracteristica("0"));
    this.props.dispatch(CambiarDescCaracteristica("0"));
    this.props.dispatch(showErrorTipo(""));
    this.props.dispatch(showErrorDesc(""));
    this.props.dispatch(openModalCaracteristicas(true));
  }

  CerrarModalModCaracteristicas = () => {
    this.props.dispatch(openModalCaracteristicas(false));
  }

  CerrarModalModPrestacion = () => {
    this.props.dispatch(openModalDetallePrestacion(false));
    this.handleselectRow("none");
  }

  CerrarModalNuevaPrestacion = () => {
    this.props.dispatch(openModalNuevaPrestacion(false));
  }

  GuardarPrestacion = () => {
    let repetida = 0;
    var prestaciones = this.props.detallePaquete;
    var prestacionesMod = this.props.detallePaqueteMod;
    if (this.props.detallePrest.codPrestador === '' || this.props.detallePrest.glosa === '' || this.props.detallePrest.imed === '' ||
      this.props.detallePrest.cantidad === '' || this.props.detallePrest.medHot === '' || this.props.detallePrest.unidad === '' ||
      this.props.detallePrest.monto === '' || this.props.detallePrest.rutBono === '') {
      this.props.dispatch(showErrorPres("Este campo es obligatorio"));
    } else {
      for (var i = 0; i < prestacionesMod.length; i++) {
        if (this.props.detallePrest.index != i) {
          if (prestacionesMod[i].TIPO_ATENCION == this.props.detallePrest.tipoAtencion &&
            prestacionesMod[i].COD_PRES_ISAP == this.props.detallePrest.codIsapre &&
            prestacionesMod[i].COD_PROF == this.props.detallePrest.codProf &&
            prestacionesMod[i].MEDICO_U_HOTELERIA == this.props.detallePrest.medHot &&
            prestacionesMod[i].BONO_RUT == this.props.detallePrest.rutBono) {
            repetida = 1;
          }
        }
      }
      if (repetida === 1) {
        this.setState({ esRepetida: true, infoMensaje: "Los datos ingresados corresponden a una prestación ya existente en el paquete." });
        this.props.dispatch(openModalDetallePrestacion(false));
      } else {
        this.props.dispatch(GuardardetallePrestacion(this.props.detallePrest));
        this.props.dispatch(openModalDetallePrestacion(false));

        if (prestaciones[this.props.detallePrest.index].TIPO_ATENCION == this.props.detallePrest.tipoAtencion &&
          prestaciones[this.props.detallePrest.index].COD_PRES_ISAP == this.props.detallePrest.codIsapre &&
          prestaciones[this.props.detallePrest.index].COD_PROF == this.props.detallePrest.codProf &&
          prestaciones[this.props.detallePrest.index].MEDICO_U_HOTELERIA == this.props.detallePrest.medHot &&
          prestaciones[this.props.detallePrest.index].BONO_RUT == this.props.detallePrest.rutBono &&
          prestaciones[this.props.detallePrest.index].CANT_PRES == this.props.detallePrest.cantidad &&
          prestaciones[this.props.detallePrest.index].COD_PRES_PREST == this.props.detallePrest.codPrestador &&
          prestaciones[this.props.detallePrest.index].GLOSA_PRES_PREST == this.props.detallePrest.glosa &&
          prestaciones[this.props.detallePrest.index].ITEM_IMED == this.props.detallePrest.imed &&
          prestaciones[this.props.detallePrest.index].MONTO_UNITARIO == this.props.detallePrest.monto &&
          prestaciones[this.props.detallePrest.index].UNIDAD == this.props.detallePrest.unidad) {
          this.setState({ esModificacion: false });
        } else {
          this.setState({ esModificacion: true });
        }
      }
    }
    this.handleselectRow("none");
  }

  GuardarNuevaPrestacion = () => {
    let repetida = 0;
    var prestacionesMod = this.props.detallePaqueteMod;
    if (this.props.detallePrest.tipoAtencion === '' || this.props.detallePrest.codPrestador === '' || this.props.detallePrest.codProf === '' ||
      this.props.detallePrest.glosa === '' || this.props.detallePrest.imed === '' || this.props.detallePrest.cantidad === '' ||
      this.props.detallePrest.medHot === '' || this.props.detallePrest.unidad === '' || this.props.detallePrest.codIsapre === '' ||
      this.props.detallePrest.monto === '' || this.props.detallePrest.rutBono === '') {
      this.props.dispatch(showErrorPres("Este campo es obligatorio"));
    } else {
      for (var i = 0; i < prestacionesMod.length; i++) {
        if (prestacionesMod[i].TIPO_ATENCION == this.props.detallePrest.tipoAtencion &&
          prestacionesMod[i].COD_PRES_ISAP == this.props.detallePrest.codIsapre &&
          prestacionesMod[i].COD_PROF == this.props.detallePrest.codProf &&
          prestacionesMod[i].MEDICO_U_HOTELERIA == this.props.detallePrest.medHot &&
          prestacionesMod[i].BONO_RUT == this.props.detallePrest.rutBono) {
          repetida = 1;
        }
      }
      if (repetida === 1) {
        this.setState({ esRepetidaEditar: true, infoMensaje: "La prestacion que desea añadir ya existe" });
        this.props.dispatch(openModalNuevaPrestacion(false));
      } else {
        this.props.dispatch(GuardardetalleNuevaPrestacion(this.props.detallePrest));
        this.props.dispatch(openModalNuevaPrestacion(false));
        this.setState({ esModificacion: true });
      }
    }
  }

  seguirEditando = () => {
    this.setState({ esRepetida: false, infoMensaje: "" });
    this.props.dispatch(openModalNuevaPrestacion(true));
  }

  cancelarEdicion = () => {
    this.setState({ esRepetida: false, infoMensaje: "" });
    this.props.dispatch(openModalNuevaPrestacion(false));
  }

  seguirEditandoEdicion = () => {
    this.setState({ esRepetidaEditar: false, infoMensaje: "" });
    this.props.dispatch(openModalDetallePrestacion(true));
  }

  cancelarEdicionEdicion = () => {
    this.setState({ esRepetidaEditar: false, infoMensaje: "" });
    this.props.dispatch(openModalDetallePrestacion(false));
  }

  GuardarCaracteristica = () => {
    if (this.props.nuevaCaracteristica === '0') {
      this.props.dispatch(showErrorTipo("Debe seleccionar una Tipo"));
    } else if (this.props.nuevaCaracteristicaDesc === '0') {
      this.props.dispatch(showErrorDesc("Debe seleccionar una Característica"));
    } else {
      this.props.dispatch(addCaracteristica(this.props.nuevaCaracteristica, this.props.nuevaCaracteristicaDesc));
      this.props.dispatch(openModalCaracteristicas(false));
      this.setState({ esModificacion: true });
    }
  }

  handleDeleteCaracteristica = (index, caracteristica) => {
    this.showInfoAlert("¿Seguro que desea eliminar el atributo " + caracteristica + "?", index);
  };

  deleteCaracteristica = (index) => {
    this.props.dispatch(eliminarCaracteristica(index));
    this.setState({ infoAlert: false, index: null, esModificacion: true });
  };

  eliminarPrestaciones = () => {
    this.showInfoAlert2("¿Seguro que desea eliminar las prestaciones seleccionadas?");
  };

  deletePrestacion = () => {
    this.props.dispatch(eliminarPrestaciones(this.state.presSeleccionadas));
    this.state.presSeleccionadas = [];
    this.state.disabledEditar = true;
    this.state.disabledEliminar = true;
    this.setState({ infoAlert2: false, infoMensaje2: "", esModificacion: true });
  }

  editarPrestacion = () => {
    this.props.dispatch(CargardetallePrestacion(this.state.presSeleccionadas[0]));
    this.props.dispatch(openModalDetallePrestacion(true));
  };

  nuevaPrestacion = () => {
    this.props.dispatch(showErrorPres(""));
    this.props.dispatch(CargardetalleNuevaPrestacion());
    this.props.dispatch(openModalNuevaPrestacion(true));
  };

  handleselectRow = (event, index, value) => {
    if (event === "all") {
      var seleccionadas = [];
      for (let i = 0; i < this.props.detallePaqueteMod.length; i++) {
        seleccionadas.push(i);
      }
      this.state.disabledEditar = true;
      this.state.disabledEliminar = false;
      this.state.presSeleccionadas = seleccionadas;
      this.props.dispatch(CambiarPrestacionesSeleccionadas(seleccionadas));
    } else if (event === "none") {
      var seleccionadas = [];
      this.state.disabledEditar = true;
      this.state.disabledEliminar = true;
      this.state.presSeleccionadas = seleccionadas;
      this.props.dispatch(CambiarPrestacionesSeleccionadas(seleccionadas));
    } else {
      var seleccionadas = [];
      for (let i = 0; i < event.length; i++) {
        seleccionadas.push(event[i]);
      }
      this.state.presSeleccionadas = seleccionadas;
      if (this.state.presSeleccionadas.length === 0) {
        this.props.dispatch(CambiarPrestacionesSeleccionadas([]));
        this.state.disabledEditar = true;
        this.state.disabledEliminar = true;
      } else if (this.state.presSeleccionadas.length === 1) {
        this.props.dispatch(CambiarPrestacionesSeleccionadas([]));
        this.state.disabledEliminar = false;
        this.state.disabledEditar = false;
      } else {
        this.state.disabledEditar = true;
        this.state.disabledEliminar = false;
        this.props.dispatch(CambiarPrestacionesSeleccionadas(seleccionadas));
      }
    }
  }

  CambiarCodigoPaquetePrestador = (event) => {
    if (event.target.value === "") {
      this.props.dispatch(showErrorPres("Este campo es obligatorio"));
    }
    this.props.dispatch(CambiarCodigoPaquetePres(event.target.value));
    if (this.props.paqueteEditar.PAQU_DESCRIPCION == event.target.value) {
      this.setState({ esModificacion: false });
    } else {
      this.setState({ esModificacion: true });
    }
  }

  CambiarCodIntervPres = (event) => {
    if (event.target.value === "") {
      this.props.dispatch(showErrorPres("Este campo es obligatorio"));
    }
    this.props.dispatch(CambiarCodIntervPres(event.target.value));

    if (this.props.paqueteEditar.PRES_CCOD_INTERV_PRES == event.target.value) {
      this.setState({ esModificacion: false });
    } else {
      this.setState({ esModificacion: true });
    }
  }

  CambiarGlosaPaquetePres = (event) => {
    if (event.target.value === "") {
      this.props.dispatch(showErrorPres("Este campo es obligatorio"));
    }
    this.props.dispatch(CambiarGlosaPaquetePres(event.target.value));
    if (this.props.paqueteEditar.PAQU_DESC_PRESTADOR == event.target.value) {
      this.setState({ esModificacion: false });
    } else {
      this.setState({ esModificacion: true });
    }
  }

  CambiarGlosaIntervPres = (event) => {
    if (event.target.value === "") {
      this.props.dispatch(showErrorPres("Este campo es obligatorio"));
    }
    this.props.dispatch(CambiarGlosaIntervPres(event.target.value));
    if (this.props.paqueteEditar.PRES_TDESC_INTERV_PRES == event.target.value) {
      this.setState({ esModificacion: false });
    } else {
      this.setState({ esModificacion: true });
    }
  }

  CambiarTipoAtencion = (event) => {
    this.props.dispatch(CambiarTipoAtencion(event.target.value));
  }

  CambiarCodPrestador = (event) => {
    this.props.dispatch(CambiarCodPrestador(event.target.value));
  }

  CambiarGlosa = (event) => {
    this.props.dispatch(CambiarGlosaPrestador(event.target.value));
  }

  CambiarItemImed = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarItemImed(event.target.value));
    }
  }

  CambiarCodIsapre = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCodIsapre(event.target.value));
    }
  }

  CambiarCantidad = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCantidadPres(event.target.value));
    }
  }

  CambiarMedHot = (event) => {
    this.props.dispatch(CambiarMedicoUHoteleria(event.target.value));
  }

  CambiarCodigoProf = (event) => {
    this.props.dispatch(CambiarCodProfesional(event.target.value));
  }

  CambiarUnidad = (event) => {
    this.props.dispatch(CambiarUnidad(event.target.value));
  }

  CambiarMonto = (event) => {
    this.props.dispatch(CambiarMonto(event.target.value));
  }

  CambiarRut = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarRutBono(event.target.value));
    }
  }

  OpenEditarPaquete = (event, index, value) => {
    //console.log("Abrir editar paquete")
  }

  ValidarModificacionSolicitud = () => {
    let paqueteEditar = this.props.paqueteEditar;
    let paqueteEditarMod = this.props.paqueteEditarMod;
    let caractPaquete = this.props.caracteristicasPaquete;
    let caractPaqueteMod = this.props.caracteristicasPaqueteMod;
    let prestaciones = this.props.detallePaquete;
    let prestacionesMod = this.props.detallePaqueteMod;
    let tieneHabitacion = 0;
    let tienePresSecundaria = 0;
    let tieneRiesgo = 0;
    let tieneTecnica = 0;
    let tieneTipoArancel = 0;
    let errorCaract = [];

    tieneHabitacion = this.props.caracteristicasPaqueteMod.filter(tipos => tipos.Tipo === ('HABITACION'));
    tienePresSecundaria = this.props.caracteristicasPaqueteMod.filter(tipos => tipos.Tipo === ('PRESTACION SECUNDARIA'));
    tieneRiesgo = this.props.caracteristicasPaqueteMod.filter(tipos => tipos.Tipo === ('RIESGO'));
    tieneTecnica = this.props.caracteristicasPaqueteMod.filter(tipos => tipos.Tipo === ('TECNICA'));
    tieneTipoArancel = this.props.caracteristicasPaqueteMod.filter(tipos => tipos.Tipo === ('TIPO ARANCEL'));

    if (tieneHabitacion.length === 0) {
      errorCaract.push("HABITACION");
    }
    if (tienePresSecundaria.length === 0) {
      errorCaract.push("PRESTACION SECUNDARIA");
    }
    if (tieneRiesgo.length === 0) {
      errorCaract.push("RIESGO");
    }
    if (tieneTecnica.length === 0) {
      errorCaract.push("TECNICA");
    }
    if (tieneTipoArancel.length === 0) {
      errorCaract.push("TIPO ARANCEL");
    }

    if (prestacionesMod.length === 0 && errorCaract.length === 0) {
      this.setState({ esModificacion: false, errorPres: true, infoMensaje: "El Paquete quirurgico debe contener a lo menos una prestación." });
    } else if (prestacionesMod.length === 0 && errorCaract.length > 0) {
      this.setState({ esModificacion: false, errorPres: true, infoMensaje: "El Paquete debe contener a lo menos una prestación.\n\rFaltan las siguientes características obligatorias: " + errorCaract.toString() + "." });
    } else if (prestacionesMod.length > 0 && errorCaract.length > 0) {
      this.setState({ esModificacion: false, errorPres: true, infoMensaje: "Faltan las siguientes características obligatorias: " + errorCaract.toString() + "." });
    } else if (paqueteEditarMod.PAQU_TERMINO_VIGENCIA != null && prestacionesMod.length > 0 && errorCaract.length === 0) {
      this.setState({ modalConfirmacion: true, infoMensaje3: "Al dar una Fecha de Fin de Vigencia solo se aplicará dicho cambio al paquete descartando cualquier otro ¿Está seguro?" });
    }
    else {
      this.setState({ modalConfirmacion: true, infoMensaje3: "Se modificará el paquete según lo señalado. ¿Está seguro?" });
    }
  }

  confirmarModMensaje = () => {
    let paqueteEditarMod = this.props.paqueteEditarMod;
    let terminoVig = paqueteEditarMod.PAQU_TERMINO_VIGENCIA;
    if (terminoVig != null) {
      this.props.dispatch(CloseEditarPrestacion());
      let paqueteEditar = this.props.paqueteEditar;
      let paqueteEditarMod = this.props.paqueteEditarMod;
      let caractPaquete = this.props.caracteristicasPaquete;
      let caractPaqueteMod = this.props.caracteristicasPaqueteMod;
      let prestaciones = this.props.detallePaquete;
      let prestacionesMod = this.props.detallePaqueteMod;
      let terminoVig = paqueteEditarMod.PAQU_TERMINO_VIGENCIA;
      let paqueteSolicitud = [];

      var resultValidacionInfoPaquete = this.validadModificacionInformacion(paqueteEditar, paqueteEditarMod);
      var resultValidacionCaractPaquete = this.validadModificacionCaracteristicas(caractPaquete, caractPaqueteMod);
      var resultValidacionPrestaciones = this.validadModificacionPrestaciones(prestaciones, prestacionesMod);

      if (resultValidacionInfoPaquete === true) {
        this.props.dispatch(limpiarPaqueteEditar({}));
        paqueteEditarMod = null;
      }
      if (resultValidacionCaractPaquete === true || terminoVig != null) {
        this.props.dispatch(cargarCaracteristicasMod([]));
        caractPaqueteMod = null;
      }
      if (resultValidacionPrestaciones === true || terminoVig != null) {
        this.props.dispatch(cargarDetalleMod([]));
        prestacionesMod = null;
      }
      paqueteSolicitud.push({ idPaqueteEditar: this.props.idPaqueteEditar, fechaInicioMod: null, paqueteEditar, paqueteEditarMod, caractPaqueteMod, prestacionesMod })
      this.props.dispatch(CargarPrestacionSolicitud(paqueteSolicitud));
    } else {
      this.setState({ modalConfirmacion: false, modalFechainicio: true });
    }
  }

  confirmarModPaquete = () => {
    if (this.state.fechaInicioMod != "") {
      this.props.dispatch(CloseEditarPrestacion());
      let paqueteEditar = this.props.paqueteEditar;
      let paqueteEditarMod = this.props.paqueteEditarMod;
      let caractPaquete = this.props.caracteristicasPaquete;
      let caractPaqueteMod = this.props.caracteristicasPaqueteMod;
      let prestaciones = this.props.detallePaquete;
      let prestacionesMod = this.props.detallePaqueteMod;
      let terminoVig = paqueteEditarMod.PAQU_TERMINO_VIGENCIA;
      let paqueteSolicitud = [];

      var resultValidacionInfoPaquete = this.validadModificacionInformacion(paqueteEditar, paqueteEditarMod);
      var resultValidacionCaractPaquete = this.validadModificacionCaracteristicas(caractPaquete, caractPaqueteMod);
      var resultValidacionPrestaciones = this.validadModificacionPrestaciones(prestaciones, prestacionesMod);

      if (resultValidacionInfoPaquete === true) {
        this.props.dispatch(limpiarPaqueteEditar({}));
        paqueteEditarMod = null;
      }
      if (resultValidacionCaractPaquete === true || terminoVig != null) {
        this.props.dispatch(cargarCaracteristicasMod([]));
        caractPaqueteMod = null;
      }
      if (resultValidacionPrestaciones === true || terminoVig != null) {
        this.props.dispatch(cargarDetalleMod([]));
        prestacionesMod = null;
      }
      paqueteSolicitud.push({ idPaqueteEditar: this.props.idPaqueteEditar, fechaInicioMod: this.state.fechaInicioMod, paqueteEditar, paqueteEditarMod, caractPaqueteMod, prestacionesMod })
      this.props.dispatch(CargarPrestacionSolicitud(paqueteSolicitud));
    } else {
      this.setState({ errorFecha: "Debe seleccionar la fecha de inicio." });
    }
  }

  validadModificacionPrestaciones = (prestaciones, prestacionesMod) => {
    let result = true;
    var aKeys = prestaciones.sort(function (a, b) {
      if (a.COD_PRES_ISAP > b.COD_PRES_ISAP) {
        return 1;
      }
      if (a.COD_PRES_ISAP < b.COD_PRES_ISAP) {
        return -1;
      }
      return 0;
    });
    var bKeys = prestacionesMod.sort(function (a, b) {
      if (a.COD_PRES_ISAP > b.COD_PRES_ISAP) {
        return 1;
      }
      if (a.COD_PRES_ISAP < b.COD_PRES_ISAP) {
        return -1;
      }
      return 0;
    });
    aKeys = aKeys.sort(function (a, b) {
      if (a.COD_PROF > b.COD_PROF) {
        return 1;
      }
      if (a.COD_PROF < b.COD_PROF) {
        return -1;
      }
      return 0;
    });
    bKeys = bKeys.sort(function (a, b) {
      if (a.COD_PROF > b.COD_PROF) {
        return 1;
      }
      if (a.COD_PROF < b.COD_PROF) {
        return -1;
      }
      return 0;
    });

    if (prestaciones.length !== prestacionesMod.length) {
      result = false;
      return result;
    }

    for (var i = 0; i < aKeys.length; i++) {
      if (aKeys[i].COD_PRES_ISAP !== bKeys[i].COD_PRES_ISAP) {
        result = false;
        return result;
      } else if (aKeys[i].COD_PROF !== bKeys[i].COD_PROF) {
        result = false;
        return result;
      } else if (aKeys[i].MONTO_UNITARIO !== bKeys[i].MONTO_UNITARIO) {
        result = false;
        return result;
      } else if (aKeys[i].BONO_RUT !== bKeys[i].BONO_RUT) {
        result = false;
        return result;
      } else if (aKeys[i].CANT_PRES !== bKeys[i].CANT_PRES) {
        result = false;
        return result;
      } else if (aKeys[i].COD_PRES_PREST !== bKeys[i].COD_PRES_PREST) {
        result = false;
        return result;
      } else if (aKeys[i].GLOSA_PRES_PREST !== bKeys[i].GLOSA_PRES_PREST) {
        result = false;
        return result;
      } else if (aKeys[i].ITEM_IMED !== bKeys[i].ITEM_IMED) {
        result = false;
        return result;
      } else if (aKeys[i].MEDICO_U_HOTELERIA !== bKeys[i].MEDICO_U_HOTELERIA) {
        result = false;
        return result;
      } else if (aKeys[i].UNIDAD !== bKeys[i].UNIDAD) {
        result = false;
        return result;
      }
    }
    return result;
  }

  validadModificacionCaracteristicas = (caractPaquete, caractPaqueteMod) => {
    var aKeys = caractPaquete.sort(function (a, b) {
      if (a.Tipo > b.Tipo) {
        return 1;
      }
      if (a.Tipo < b.Tipo) {
        return -1;
      }
      return 0;
    });
    var bKeys = caractPaqueteMod.sort(function (a, b) {
      if (a.Tipo > b.Tipo) {
        return 1;
      }
      if (a.Tipo < b.Tipo) {
        return -1;
      }
      return 0;
    });
    let result = true;

    if (caractPaquete.length !== caractPaqueteMod.length) {
      result = false;
      return result;
    }
    if (aKeys.join('') !== bKeys.join('')) {
      result = false;
      return result;
    }
    for (var i = 0; i < aKeys.length; i++) {
      if (aKeys[i].Tipo !== bKeys[i].Tipo) {
        result = false;
        return result;
      } else if (aKeys[i].Tipo === bKeys[i].Tipo && aKeys[i].Descripcion !== bKeys[i].Descripcion) {
        result = false;
        return result;
      }
    }
    return result;
  }

  validadModificacionInformacion = (paqueteEditar, paqueteEditarMod) => {
    var aKeys = Object.keys(paqueteEditar).sort();
    var bKeys = Object.keys(paqueteEditarMod).sort();
    let result = true;

    if (aKeys.length !== bKeys.length) {
      result = false;
      return result;
    }
    if (aKeys.join('') !== bKeys.join('')) {
      result = false;
      return result;
    }
    for (var i = 0; i < aKeys.length; i++) {
      if (paqueteEditar[aKeys[i]] !== paqueteEditarMod[bKeys[i]]) {
        result = false;
        return result;
      }
    }
    return result;
  }

  validadModificacionInformacion2 = (paqueteEditar, paqueteEditarMod) => {
    var aKeys = Object.keys(paqueteEditar).sort();
    var bKeys = Object.keys(paqueteEditarMod).sort();
    let result = true;

    if (aKeys.length !== bKeys.length) {
      result = false;
      return result;
    }
    if (aKeys.join('') !== bKeys.join('')) {
      result = false;
      return result;
    }
    //console.log(aKeys)
    for (var i = 0; i < aKeys.length; i++) {
      //console.log(aKeys[i])
      if (paqueteEditar[aKeys[i]] !== paqueteEditarMod[bKeys[i]]) {
        if (aKeys[i] === 'PAQU_TERMINO_VIGENCIA' && bKeys[i] === 'PAQU_TERMINO_VIGENCIA') {
          result = true;
        } else {
          result = false;
          return result;
        }
      }
    }
    return result;
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const largoCaract = this.props.caracteristicasPaqueteMod.length;
    const unicas = [...new Set(this.props.caracteristicas.map(item => item.Tipo))];
    const largoUnicas = unicas.length;

    const menuListCaracteristicas = [];
    this.props.caracteristicasPaqueteMod.map((row, index) => {
      (menuListCaracteristicas.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.datoTablaCaracteristicasP1}>
            {row.Tipo}
          </TableRowColumn>
          <TableRowColumn style={styles.datoTablaCaracteristicasP1}>
            <SelectField
              name={"dd_fb_tipoAtributo_"}
              id={"dd_fb_tipoAtributo_"}
              value={this.props.caracteristicasPaqueteMod[index].Tipo + "-" + this.props.caracteristicasPaqueteMod[index].Descripcion}
              onChange={this.CambiarCaracteristica}
              labelStyle={styles.h4}
              underlineStyle={styles.underlineSelectField}
              style={styles.selectFiledStyle}
              iconStyle={styles.iconSelectField}
              menuItemStyle={styles.menuItemStyleSelectField}
              selectedMenuItemStyle={styles.selectedMenuItemSelectField}
            >
              {this.menuListTipoAtributo(row.Tipo, row.Descripcion)}
            </SelectField>
            <DeleteIcon
              style={{ float: "right", width: "15%", cursor: "pointer" }}
              onClick={() => this.handleDeleteCaracteristica(index, this.props.caracteristicasPaqueteMod[index].Tipo)} />
          </TableRowColumn>
        </TableRow>
      ))
      )
      //}
    });

    const menuListDetalle = [];
    this.props.detallePaqueteMod.map((row, index) => (
      menuListDetalle.push((
        <TableRow key={index} selected={this.state.presSeleccionadas.indexOf(index) !== -1}>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.TIPO_ATENCION}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PRES_ISAP}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PRES_PREST}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.GLOSA_PRES_PREST}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.ITEM_IMED}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.COD_PROF}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.CANT_PRES}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{(row.MONTO_UNITARIO).toLocaleString('de-DE')}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.UNIDAD}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.MEDICO_U_HOTELERIA}</TableRowColumn>
          <TableRowColumn style={styles.datoTablaDetalleP1}>{row.BONO_RUT}</TableRowColumn>
        </TableRow>
      ))
    ));

    const menuListTipoCaracteristica = [];
    if (this.props.caracteristicas) {
      const unique = [...new Set(this.props.caracteristicas.map(item => item.Tipo))];
      menuListTipoCaracteristica.push(<MenuItem key="0" value="0" primaryText="Seleccionar" style={styles.customWidthItem} />);
      for (let i = 1; i <= unique.length; i++) {
        const result = this.props.caracteristicasPaqueteMod.filter(tipos => tipos.Tipo === unique[i - 1]);
        if (result.length === 0) {
          menuListTipoCaracteristica.push(<MenuItem key={i} value={unique[i - 1]} primaryText={unique[i - 1]} style={styles.customWidthItem} />);
        }
      }
    }

    const menuListDescripcionCaracteristicaAdd = [];
    menuListDescripcionCaracteristicaAdd.push(<MenuItem key="0" value="0" primaryText="Seleccionar" style={styles.customWidthItem} />);
    if (this.props.nuevaCaracteristica != '0') {
      const result = this.props.caracteristicas.filter(tipos => tipos.Tipo === this.props.nuevaCaracteristica);
      for (let i = 1; i <= result.length; i++) {
        menuListDescripcionCaracteristicaAdd.push(<MenuItem key={i} value={result[i - 1].Descripcion} primaryText={result[i - 1].Descripcion} style={styles.customWidthItem} />);
      }
    }

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Modificar Paquete
                  </div>
                  <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                  </div>
                </div>
              </div>


              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Paquete:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.paquete.codPaquete}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Paquete Prestador*:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <TextField
                        name="txt_fb_codpres"
                        id="txt_fb_codpres"
                        value={this.props.paquete.codPaquetePres || ""}
                        onChange={this.CambiarCodigoPaquetePrestador}
                        maxLength={15}
                        underlineStyle={styles.underlineSelectField}
                        inputStyle={styles.h4}
                        style={styles.selectFiledStyle2}
                        errorText={this.props.errorPrestacion != '' && this.props.paquete.codPaquetePres === '' ? this.props.errorPrestacion : ""}
                        errorStyle={{ bottom: "-6px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Intervención:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.paquete.codInterv}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Intervención Prestador*:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <TextField
                        name="txt_fb_codIntpres"
                        id="txt_fb_codIntpres"
                        value={this.props.paquete.codIntervPres || ""}
                        onChange={this.CambiarCodIntervPres}
                        maxLength={15}
                        underlineStyle={styles.underlineSelectField}
                        inputStyle={styles.h4}
                        style={styles.selectFiledStyle2}
                        errorText={this.props.errorPrestacion != '' && this.props.paquete.codIntervPres === '' ? this.props.errorPrestacion : ""}
                        errorStyle={{ bottom: "-6px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Fecha Inicio Vigencia:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {(new Date(this.props.paquete.fechaInicioVigencia)).toLocaleDateString("en-GB", { timeZone: "UTC" })}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Observaciones:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.paquete.observacion}
                    </div>
                  </div>
                </div>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Glosa Paquete:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.paquete.glosaPaquete}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Glosa Paquete Prestador*:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <TextField
                        name="txt_fb_codIntpres"
                        id="txt_fb_codIntpres"
                        value={this.props.paquete.glosaPaquetePres || ""}
                        onChange={this.CambiarGlosaPaquetePres}
                        maxLength={200}
                        underlineStyle={styles.underlineSelectField}
                        inputStyle={styles.h4}
                        style={styles.selectFiledStyle2}
                        errorText={this.props.errorPrestacion != '' && this.props.paquete.glosaPaquetePres === '' ? this.props.errorPrestacion : ""}
                        errorStyle={{ bottom: "-6px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Atributo Paquete:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.paquete.codigoAtributo}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Glosa Intervención Prestador*:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <TextField
                        name="txt_fb_codIntpres"
                        id="txt_fb_codIntpres"
                        value={this.props.paquete.glosaIntervPres || ""}
                        onChange={this.CambiarGlosaIntervPres}
                        maxLength={200}
                        underlineStyle={styles.underlineSelectField}
                        inputStyle={styles.h4}
                        style={styles.selectFiledStyle2}
                        errorText={this.props.errorPrestacion != '' && this.props.paquete.glosaIntervPres === '' ? this.props.errorPrestacion : ""}
                        errorStyle={{ bottom: "-6px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Fin Vigencia Paquete:
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <div className="container">
                        <div className="row">
                          <DatePicker
                            name="dp_npf_inicioVigencia"
                            id="dp_npf_inicioVigencia"
                            mode="landscape"
                            DateTimeFormat={customDateTimeFormat.cl()}
                            locale="es-CL"
                            firstDayOfWeek={1}
                            minDate={minDate}
                            value={this.props.paquete.fechaFinVigencia || ""}
                            onChange={this.CambiarVigenciaPrestacionEdicion}
                            onDismiss={() => this.LimpiarVigenciaPrestacionEdicion(null)}
                            underlineStyle={styles.underlineSelectField}
                            style={{ ...styles.datepickerStyle, width: "80%" }}
                            inputStyle={styles.h4}
                          //errorText={this.props.inicioVigenciaArancelErr || ""}
                          />
                          <DateIcon
                            style={{ float: "right", width: "15%" }}
                            color={banmedicaTheme.palette.accent1Color}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div className="row" style={{ paddingBottom: 15, marginTop: 25 }}>
                <div style={styles.h1}>Características
                </div>
                <div>
                  <RaisedButton
                    onClick={this.addCaracteristica}
                    label="Añadir"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 25 }}
                    buttonStyle={{ borderRadius: 5 }}
                    disabled={(largoUnicas - largoCaract) === 0}
                  />
                </div>
                <div className="row" style={{ paddingBottom: 25 }}></div>
                <div id="tablaModalCaracteristicas" style={{ overflow: "auto" }}>
                  <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                    <Table
                      key="tablaModalCaracteristicas"
                      fixedHeader
                      selectable={false}
                      style={{ overflow: "hidden" }}
                    >
                      <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                        <TableRow selectable={false}>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Tipo Atributo</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP2}>Descripción</TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody
                        id="tablaBodyModalCaracteristicas"
                        displayRowCheckbox={false}
                        deselectOnClickaway={false}
                        stripedRows
                      >
                        {menuListCaracteristicas}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>

              <div className="row" style={{ paddingBottom: 15, marginTop: 25 }}>
                <div style={styles.h1}>Prestaciones en el Paquete</div>
                <div>
                  <RaisedButton
                    onClick={this.nuevaPrestacion}
                    label="Añadir"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 25 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
                <div>
                  <RaisedButton
                    onClick={this.eliminarPrestaciones}
                    label="Eliminar"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 25 }}
                    buttonStyle={{ borderRadius: 5 }}
                    disabled={this.state.disabledEliminar === true}
                  />
                </div>
                <div>
                  <RaisedButton
                    onClick={this.editarPrestacion}
                    label="Editar"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 25 }}
                    buttonStyle={{ borderRadius: 5 }}
                    disabled={this.state.disabledEditar === true}
                  />
                </div>
                <div className="row" style={{ marginTop: 25, paddingBottom: 25 }}></div>
                <div id="tablaModalDetalleP" style={{ overflow: "auto" }}>
                  <div style={{ width: "fit-content", overflowX: "auto", textAlign: "left" }}>
                    <Table
                      key="tablaModalDetalleP"
                      fixedHeader
                      selectable={true}
                      multiSelectable={true}
                      onRowSelection={this.handleselectRow}
                      style={{ overflow: "hidden" }}
                    >
                      <TableHeader>
                        <TableRow selectable={false}>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Tipo Atención</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Fonasa</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Prestador</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Glosa<br />Prestador</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Item IMED</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Código<br />Profesional</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Cantidad</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Monto Unitario</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Unidad</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Médico u Hotelería</TableHeaderColumn>
                          <TableHeaderColumn style={styles.tituloTablaBusquedaP1}>Bono RUT</TableHeaderColumn>
                        </TableRow>
                      </TableHeader>
                      <TableBody
                        id="tablaBodyModalDetalle"
                        //displayRowCheckbox={true}
                        deselectOnClickaway={false}
                        stripedRows
                      >
                        {menuListDetalle}
                      </TableBody>
                    </Table>
                  </div>
                </div>
              </div>



              {/*this.props.loadingArbolDetalle ?
                <CircularProgress></CircularProgress>
                :
                tableArbol
              */}


              <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="col-12" style={{ textAlign: "right" }}>
                  <RaisedButton
                    onClick={this.CloseEditarPrestacion}
                    label="Cancelar"
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                  <RaisedButton
                    disabled={this.state.esModificacion === false}
                    onClick={this.ValidarModificacionSolicitud}
                    label="Modificar"
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
            </CardText>
          </Card>

          <Dialog
            key="dialogEliminarCaract"
            id="dialogEliminarCaract"
            actions={[
              <FlatButton
                label="Confirmar"
                primary
                onClick={() => this.deleteCaracteristica(this.state.index)}
              />,
              <FlatButton
                label="Cancelar"
                primary
                onClick={() => this.setState({ infoAlert: false, index: null })}
              />
            ]}
            modal
            open={this.state.infoAlert}
            style={{ width: "700px", fontSize: "13px" }}
          >
            {this.state.infoMensaje}
          </Dialog>

          <Dialog
            key="dialogEliminarPrest"
            id="dialogEliminarPrest"
            actions={[
              <FlatButton
                label="Confirmar"
                primary
                onClick={this.deletePrestacion}
              />,
              <FlatButton
                label="Cancelar"
                primary
                onClick={() => this.setState({ infoAlert2: false, infoMensaje2: "" })}
              />
            ]}
            modal
            open={this.state.infoAlert2}
            style={{ width: "700px", fontSize: "13px" }}
          >
            {this.state.infoMensaje2}
          </Dialog>

          <Dialog
            key="dialogPresRepetida"
            id="dialogPresRepetida"
            actions={[
              <FlatButton
                label="Seguir Editando"
                primary
                onClick={this.seguirEditando}
              />,
              <FlatButton
                label="Cancelar"
                primary
                onClick={this.cancelarEdicion}
              />
            ]}
            modal
            open={this.state.esRepetida}
            style={{ width: "700px", fontSize: "13px" }}
          >
            {this.state.infoMensaje}
          </Dialog>

          <Dialog
            key="dialogPresRepetidaEditar"
            id="dialogPresRepetidaEditar"
            actions={[
              <FlatButton
                label="Seguir Editando"
                primary
                onClick={this.seguirEditandoEdicion}
              />,
              <FlatButton
                label="Cancelar"
                primary
                onClick={this.cancelarEdicionEdicion}
              />
            ]}
            modal
            open={this.state.esRepetidaEditar}
            style={{ width: "700px", fontSize: "13px" }}
          >
            {this.state.infoMensaje}
          </Dialog>

          <Dialog
            key="dialogFaltanPres"
            id="dialogFaltanPres"
            actions={[
              <FlatButton
                label="Cerrar"
                primary
                onClick={() => this.setState({ errorPres: false, infoMensaje: "" })}
              />
            ]}
            modal
            open={this.state.errorPres}
            style={{ width: "700px", fontSize: "13px" }}
          >
            {this.state.infoMensaje}
          </Dialog>

          <Dialog
            key="dialogConfirmarEdicion"
            id="dialogConfirmarEdicion"
            actions={[
              <FlatButton
                label="Confirmar"
                primary
                onClick={this.confirmarModMensaje}
              />,
              <FlatButton
                label="Cancelar"
                primary
                onClick={() => this.setState({ modalConfirmacion: false, infoMensaje3: "" })}
              />
            ]}
            modal
            open={this.state.modalConfirmacion}
            style={{ width: "700px", fontSize: "13px" }}
          >
            {this.state.infoMensaje3}
          </Dialog>

          <Dialog
            key="dialogConfirmarFecha"
            id="dialogConfirmarFecha"
            //title="Fecha Inicio Modificación"
            actions={[
              <FlatButton
                label="Confirmar"
                primary
                onClick={this.confirmarModPaquete}
              />,
              <FlatButton
                label="Cancelar"
                primary
                onClick={() => this.setState({ modalFechainicio: false, fechaInicioMod: "", errorFecha: "" })}
              />
            ]}
            modal
            open={this.state.modalFechainicio}
            style={{ width: "700px", fontSize: "13px" }}
          >
            <div className="row">
              <div className="col-5" style={styles.tituloModificarPrestacion}>
                Fecha de Inicio de la Modificación:
              </div>
              <div className="col-6" style={styles.datoModificarPrestacion}>
                <div className="container">
                  <div className="row">
                    <DatePicker
                      name="dp_npf_inicioVigencia"
                      id="dp_npf_inicioVigencia"
                      mode="landscape"
                      DateTimeFormat={customDateTimeFormat.cl()}
                      locale="es-CL"
                      firstDayOfWeek={1}
                      minDate={minDate}
                      value={this.state.fechaInicioMod || ""}
                      onChange={this.CambiarVigenciaPaqueteEdicion}
                      underlineStyle={styles.underlineSelectField}
                      style={{ ...styles.datepickerStyle, width: "80%" }}
                      inputStyle={styles.h4}
                      errorText={this.state.errorFecha != "" ? this.state.errorFecha : ""}
                      errorStyle={{ bottom: "-6px" }}
                    />
                    <DateIcon
                      style={{ float: "right", width: "15%" }}
                      color={banmedicaTheme.palette.accent1Color}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Dialog>

        </div>

        {this.props.openModalAddCaracteristicas ?
          <Dialog
            key="modalAddCaracteristicas"
            actions={[
              <FlatButton
                label="Guardar"
                secondary
                onClick={this.GuardarCaracteristica}
              />,
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalModCaracteristicas}
              />]}
            modal
            open={this.props.openModalAddCaracteristicas}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Añadir Característica
            </div>
            <div className="row" style={{ paddingBottom: 25 }}></div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect2}>Tipo de Atributo</div>
                {
                  this.props.caracteristicas && this.props.caracteristicas.length > 0 ?
                    <SelectField
                      name="dd_fb_tipoAtributo"
                      id="dd_fb_tipoAtributo"
                      value={this.props.nuevaCaracteristica}
                      onChange={this.CargarAtributosTipo}
                      labelStyle={styles.h4}
                      underlineStyle={styles.underlineSelectField}
                      style={styles.selectFiledStyle}
                      iconStyle={styles.iconSelectField}
                      menuItemStyle={styles.menuItemStyleSelectField}
                      selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                      errorText={this.props.errorCaract || ""}
                      errorStyle={{ bottom: "-6px" }}
                    >
                      {menuListTipoCaracteristica}
                    </SelectField>
                    :
                    <CircularProgress />
                }
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect2}> Descripción </div>
                {
                  this.props.caracteristicas && this.props.caracteristicas.length > 0 ?
                    <SelectField
                      name="dd_fb_Descripción"
                      id="dd_fb_Descripción"
                      value={this.props.nuevaCaracteristicaDesc}
                      onChange={this.GuardarAtributos}
                      labelStyle={styles.h4}
                      underlineStyle={styles.underlineSelectField}
                      style={styles.selectFiledStyle}
                      iconStyle={styles.iconSelectField}
                      menuItemStyle={styles.menuItemStyleSelectField}
                      selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                      errorText={this.props.errorDesc || ""}
                      errorStyle={{ bottom: "-6px" }}
                    >
                      {menuListDescripcionCaracteristicaAdd}
                    </SelectField>
                    :
                    <CircularProgress />
                }
              </div>
            </div>
          </Dialog> : null}

        {this.props.openModalEditarPrestacion ?
          <Dialog
            key="modalEditarPrestacion"
            actions={[
              <FlatButton
                label="Guardar"
                secondary
                onClick={this.GuardarPrestacion}
              />,
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalModPrestacion}
              />]}
            modal
            open={this.props.openModalEditarPrestacion}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Editar Prestacion</div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Tipo Atención (A - H) </div>
                <TextField
                  name="txt_fb_tipoAtencion"
                  id="txt_fb_tipoAtencion"
                  value={this.props.detallePrest.tipoAtencion || ""}
                  maxLength={1}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  disabled={true}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Código Fonasa </div>
                <TextField
                  name="txt_fb_codIsapre"
                  id="txt_fb_codIsapre"
                  value={this.props.detallePrest.codIsapre || ""}
                  disabled={true}
                  maxLength={10}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Codigo Prestación Prestador </div>
                <TextField
                  name="txt_fb_codpres"
                  id="txt_fb_codpres"
                  value={this.props.detallePrest.codPrestador || ""}
                  onChange={this.CambiarCodPrestador}
                  maxLength={15}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.codPrestador === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Glosa Prestación Prestador </div>
                <TextField
                  name="txt_fb_glosa"
                  id="txt_fb_glosa"
                  value={this.props.detallePrest.glosa || ""}
                  onChange={this.CambiarGlosa}
                  maxLength={300}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.glosa === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Item IMED Prestador </div>
                <TextField
                  name="txt_fb_imed"
                  id="txt_fb_imed"
                  value={this.props.detallePrest.imed >= 0 ? this.props.detallePrest.imed : ""}
                  onChange={this.CambiarItemImed}
                  maxLength={1}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.imed === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Código Profesional </div>
                <TextField
                  name="txt_fb_codProf"
                  id="txt_fb_codProf"
                  value={this.props.detallePrest.codProf || ""}
                  disabled={true}
                  maxLength={10}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Cantidad </div>
                <TextField
                  name="txt_fb_codpres"
                  id="txt_fb_codpres"
                  value={this.props.detallePrest.cantidad >= 0 ? this.props.detallePrest.cantidad : ""}
                  onChange={this.CambiarCantidad}
                  maxLength={2}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.cantidad === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Medico u Hotelería (M - H) </div>
                <TextField
                  name="txt_fb_medHot"
                  id="txt_fb_medHot"
                  value={this.props.detallePrest.medHot || ""}
                  onChange={this.CambiarMedHot}
                  maxLength={1}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.medHot === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Unidad (PE - VC - VE)</div>
                <TextField
                  name="txt_fb_unidad"
                  id="txt_fb_unidad"
                  value={this.props.detallePrest.unidad || ""}
                  onChange={this.CambiarUnidad}
                  maxLength={2}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.unidad === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Monto Unitario </div>
                <TextField
                  name="txt_fb_monto"
                  id="txt_fb_monto"
                  value={this.props.detallePrest.monto >= 0 ? this.props.detallePrest.monto : ""}
                  onChange={this.CambiarMonto}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.monto === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Rut Bono </div>
                <TextField
                  name="txt_fb_rut"
                  id="txt_fb_rut"
                  value={this.props.detallePrest.rutBono || ""}
                  onChange={this.CambiarRut}
                  maxLength={9}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.rutBono === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
          </Dialog> : null}

        {this.props.openModalAddPrestacion ?
          <Dialog
            key="modalAgregarPrestacion"
            actions={[
              <FlatButton
                label="Guardar"
                secondary
                onClick={this.GuardarNuevaPrestacion}
              />,
              <FlatButton
                label="Cerrar"
                secondary
                onClick={this.CerrarModalNuevaPrestacion}
              />]}
            modal
            open={this.props.openModalAddPrestacion}
            style={{ width: "100%", fontSize: "13px" }}
          >
            <div style={styles.h1}>Añadir Prestacion</div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Tipo Atención (A - H) </div>
                <TextField
                  name="txt_fb_tipoAtencion"
                  id="txt_fb_tipoAtencion"
                  value={this.props.detallePrest.tipoAtencion || ""}
                  maxLength={1}
                  onChange={this.CambiarTipoAtencion}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.tipoAtencion === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Código Fonasa </div>
                <TextField
                  name="txt_fb_codIsapre"
                  id="txt_fb_codIsapre"
                  value={this.props.detallePrest.codIsapre || ""}
                  onChange={this.CambiarCodIsapre}
                  maxLength={10}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.codIsapre === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Codigo Prestación Prestador </div>
                <TextField
                  name="txt_fb_codpres"
                  id="txt_fb_codpres"
                  value={this.props.detallePrest.codPrestador || ""}
                  onChange={this.CambiarCodPrestador}
                  maxLength={15}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.codPrestador === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Glosa Prestación Prestador </div>
                <TextField
                  name="txt_fb_glosa"
                  id="txt_fb_glosa"
                  value={this.props.detallePrest.glosa || ""}
                  onChange={this.CambiarGlosa}
                  maxLength={300}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.glosa === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Item IMED Prestador </div>
                <TextField
                  name="txt_fb_imed"
                  id="txt_fb_imed"
                  value={this.props.detallePrest.imed >= 0 ? this.props.detallePrest.imed : ""}
                  onChange={this.CambiarItemImed}
                  maxLength={1}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.imed === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Código Profesional </div>
                <TextField
                  name="txt_fb_codProf"
                  id="txt_fb_codProf"
                  value={this.props.detallePrest.codProf || ""}
                  onChange={this.CambiarCodigoProf}
                  maxLength={10}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.codProf === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Cantidad </div>
                <TextField
                  name="txt_fb_codpres"
                  id="txt_fb_codpres"
                  value={this.props.detallePrest.cantidad >= 0 ? this.props.detallePrest.cantidad : ""}
                  onChange={this.CambiarCantidad}
                  maxLength={2}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.cantidad === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Medico u Hotelería (M - H)</div>
                <TextField
                  name="txt_fb_medHot"
                  id="txt_fb_medHot"
                  value={this.props.detallePrest.medHot || ""}
                  onChange={this.CambiarMedHot}
                  maxLength={1}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.medHot === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Unidad (PE - VC - VE)</div>
                <TextField
                  name="txt_fb_unidad"
                  id="txt_fb_unidad"
                  value={this.props.detallePrest.unidad || ""}
                  onChange={this.CambiarUnidad}
                  maxLength={2}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.unidad === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
              <div className="col-4" style={{ paddingLeft: 40 }}>
                <div style={styles.floatingClaseSelect}> Monto Unitario </div>
                <TextField
                  name="txt_fb_monto"
                  id="txt_fb_monto"
                  value={this.props.detallePrest.monto >= 0 ? this.props.detallePrest.monto : ""}
                  onChange={this.CambiarMonto}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.monto === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4" style={{ paddingLeft: 20 }}>
                <div style={styles.floatingClaseSelect}> Rut Bono </div>
                <TextField
                  name="txt_fb_rut"
                  id="txt_fb_rut"
                  value={this.props.detallePrest.rutBono || ""}
                  onChange={this.CambiarRut}
                  maxLength={9}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFiledStyle}
                  errorText={this.props.errorPrestacion != '' && this.props.detallePrest.rutBono === '' ? this.props.errorPrestacion : ""}
                  errorStyle={{ bottom: "-6px" }}
                />
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}


EditarPaqueteForm.defaultProps = {
  vigenciaPrestacionEdicion: null,
  tipoUnidadReplicar: null,
  // montoMaximoFonasa: null,
};

EditarPaqueteForm.propTypes = {
  dupsMsg: PropTypes.string.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  aceptaGuardadoModalEdicion: PropTypes.bool.isRequired,
  vigenciaPrestacionEdicion: PropTypes.instanceOf(Date),
  // valorPrestacion: PropTypes.number.isRequired,
  centrosAtencionPrestacion: PropTypes.array.isRequired,
  tiposArancelPrestacion: PropTypes.array.isRequired,
  tiposUnidad: PropTypes.array.isRequired,
  tiposProfesionales: PropTypes.array.isRequired,
  prestacionesSeleccionadas: PropTypes.array.isRequired,
  tipoUnidadReplicar: PropTypes.string,
  valorMaxPres: PropTypes.array.isRequired,
  // montoMaximoFonasa: PropTypes.number,
  detallePrestacion: PropTypes.any.isRequired,
  paquete: PropTypes.any.isRequired,
  detallePrest: PropTypes.any,
  ENV: PropTypes.any.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  //inicioVigenciaArancelErr: PropTypes.string.isRequired,
  loadingArbolDetalle: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
  caracteristicasPaquete: PropTypes.array.isRequired,
  caracteristicas: PropTypes.array.isRequired,
  detallePaquete: PropTypes.array.isRequired,
  detallePaqueteMod: PropTypes.array.isRequired,
  prestacionesSeleccionadasPQ: PropTypes.array,
  caracteristicasPaqueteMod: PropTypes.any,
  nuevaCaracteristica: PropTypes.any,
  nuevaCaracteristicaDesc: PropTypes.any,
  openModalAddCaracteristicas: PropTypes.bool,
  openModalEditarPrestacion: PropTypes.bool,
  openModalAddPrestacion: PropTypes.bool,
  errorDesc: PropTypes.any,
  errorCaract: PropTypes.any,
  errorPrestacion: PropTypes.any,
  idPaqueteEditar: PropTypes.any,
  paqueteEditar: PropTypes.array,
  paqueteEditarMod: PropTypes.array,
};

const mapStateToProps = (state) => ({
  dupsMsg: state.editarPrestacionForm.dupsMsg,
  isapre: state.global.isapre,
  rutInstitucion: state.global.rutInstitucion,
  aceptaGuardadoModalEdicion: state.editarPrestacionForm.aceptaGuardadoModalEdicion,
  vigenciaPrestacionEdicion: state.editarPrestacionForm.vigenciaPrestacionEdicion,
  valorPrestacion: state.editarPrestacionForm.valorPrestacion,
  centrosAtencionPrestacion: state.editarPrestacionForm.centrosAtencionPrestacion,
  tiposArancelPrestacion: state.editarPrestacionForm.tiposArancelPrestacion,
  tiposUnidad: state.global.tiposUnidad,
  tiposProfesionales: state.global.tiposProfesionales,
  prestacionesSeleccionadas: state.editarPrestacionForm.prestacionesSeleccionadas,
  tipoUnidadReplicar: state.editarPrestacionForm.tipoUnidadReplicar,
  valorMaxPres: state.editarPrestacionForm.valorMaxPres,
  paqueteEditarMod: state.grillaBusquedaPQ.paqueteEditarMod,
  paqueteEditar: state.grillaBusquedaPQ.paqueteEditar,
  // montoMaximoFonasa: state.global.montoMaximoFonasa,
  detallePrestacion: {
    codigoPrestacionPrestador: state.editarPrestacionForm.detallePrestacion.codigoPrestacionPrestador,
    pabellonPrestacion: state.editarPrestacionForm.detallePrestacion.pabellonPrestacion,
    glosaPrestacionPrestador: state.editarPrestacionForm.detallePrestacion.glosaPrestacionPrestador,
    codigoFonasa: state.editarPrestacionForm.detallePrestacion.codigoFonasa,
    grupoPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.grupoPrestacionIsapre,
    codigoPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.codigoPrestacionIsapre,
    glosaPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.glosaPrestacionIsapre,
    codigoProfesional: state.editarPrestacionForm.detallePrestacion.codigoProfesional,
    montoArancelPrestacion: state.editarPrestacionForm.detallePrestacion.montoArancelPrestacion,
    montoArancelError: state.editarPrestacionForm.detallePrestacion.montoArancelError,
    unidadArancelPrestacion: state.editarPrestacionForm.detallePrestacion.unidadArancelPrestacion,
    inicioVigenciaArancelPrev: state.editarPrestacionForm.detallePrestacion.inicioVigenciaArancelPrev,
    tipoAtencion: state.editarPrestacionForm.detallePrestacion.tipoAtencion,
    grupoPrestacionPrestador: state.editarPrestacionForm.detallePrestacion.grupoPrestacionPrestador,
    itemImed: state.editarPrestacionForm.detallePrestacion.itemImed,
    glosagGupoPrestacionIsapre: state.editarPrestacionForm.detallePrestacion.glosagGupoPrestacionIsapre,
    idPrestacion: state.editarPrestacionForm.detallePrestacion.idPrestacion
  },
  paquete: {
    codPaquete: state.grillaBusquedaPQ.paqueteEditarMod.PAQU_CODIGO,
    codPaquetePres: state.grillaBusquedaPQ.paqueteEditarMod.PAQU_CODIGO_PRESTADOR,
    codInterv: state.grillaBusquedaPQ.paqueteEditarMod.PRES_CCOD_INTERV,
    codIntervPres: state.grillaBusquedaPQ.paqueteEditarMod.PRES_CCOD_INTERV_PRES,
    fechaInicioVigencia: state.grillaBusquedaPQ.paqueteEditarMod.PAQU_INICIO_VIGENCIA,
    fechaFinVigencia: state.grillaBusquedaPQ.paqueteEditarMod.PAQU_TERMINO_VIGENCIA,
    totalPaquete: state.grillaBusquedaPQ.paqueteEditarMod.PAQU_MONTO_TOTAL,
    glosaPaquete: state.grillaBusquedaPQ.paqueteEditarMod.PAQU_DESCRIPCION,
    glosaPaquetePres: state.grillaBusquedaPQ.paqueteEditarMod.PAQU_DESC_PRESTADOR,
    codigoAtributo: state.grillaBusquedaPQ.paqueteEditarMod.PAAT_CCOD_OLD,
    glosaIntervPres: state.grillaBusquedaPQ.paqueteEditarMod.PRES_TDESC_INTERV_PRES,
    observacion: state.grillaBusquedaPQ.paqueteEditarMod.OBSERVACION,
  },
  detallePrest: {
    tipoAtencion: state.grillaBusquedaPQ.detalle.tipoAtencion,
    cantidad: state.grillaBusquedaPQ.detalle.cantidad,
    codIsapre: state.grillaBusquedaPQ.detalle.codIsapre,
    codPrestador: state.grillaBusquedaPQ.detalle.codPrestador,
    codProf: state.grillaBusquedaPQ.detalle.codProf,
    glosa: state.grillaBusquedaPQ.detalle.glosa,
    imed: state.grillaBusquedaPQ.detalle.imed,
    medHot: state.grillaBusquedaPQ.detalle.medHot,
    monto: state.grillaBusquedaPQ.detalle.monto,
    rutBono: state.grillaBusquedaPQ.detalle.rutBono,
    unidad: state.grillaBusquedaPQ.detalle.unidad,
    grupo: state.grillaBusquedaPQ.detalle.grupo,
    index: state.grillaBusquedaPQ.detalle.index,
  },
  ENV: state.global.ENV,
  prestacionesSolicitud: state.grillaSolicitud.prestacionesSolicitud,
  //inicioVigenciaArancelErr: state.editarPrestacionForm.inicioVigenciaArancelErr,
  loadingArbolDetalle: state.editarPrestacionForm.loadingArbolDetalle,
  caracteristicas: state.filtroBusquedaPQ.tiposAtencion,
  caracteristicasPaquete: state.grillaBusquedaPQ.caracteristicasPaquete,
  caracteristicasPaqueteMod: state.grillaBusquedaPQ.caracteristicasPaqueteMod,
  nuevaCaracteristica: state.editarPaqueteForm.nuevaCaracteristica,
  nuevaCaracteristicaDesc: state.editarPaqueteForm.nuevaCaracteristicaDesc,
  detallePaquete: state.grillaBusquedaPQ.detallePaquete,
  detallePaqueteMod: state.grillaBusquedaPQ.detallePaqueteMod,
  openModalAddCaracteristicas: state.editarPaqueteForm.openModalAddCaracteristicas,
  openModalEditarPrestacion: state.grillaBusquedaPQ.openModalEditarPrestacion,
  openModalAddPrestacion: state.editarPaqueteForm.openModalAddPrestacion,
  prestacionesSeleccionadasPQ: state.grillaBusquedaPQ.prestacionesSeleccionadasPQ,
  errorCaract: state.editarPaqueteForm.errorCaract,
  errorDesc: state.editarPaqueteForm.errorDesc,
  errorPrestacion: state.editarPaqueteForm.errorPrestacion,
  idPaqueteEditar: state.grillaBusquedaPQ.idPaqueteEditar,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(EditarPaqueteForm);




// WEBPACK FOOTER //
// ./src/components/Paquetes/EditarPrestacionForm/view.jsx